import React from "react";
import { useParams } from "react-router-dom";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from "@coreui/react";

const employees = [
  {
    id: 1,
    ten: "Trần Viễn",
    ma: "NV001",
    chucvu: "CEO",
    phongban: "Ban giám đốc",
    luongthang: "50,000,000",
    sogiolam: 160,
    dukien: "50,000,000",
    phat: "0",
    tongnhan: "50,000,000",
  },
  {
    id: 2,
    ten: "Nguyễn Mai Phương",
    ma: "NV002",
    chucvu: "CTO",
    phongban: "Công nghệ",
    luongthang: "40,000,000",
    sogiolam: 155,
    dukien: "40,000,000",
    phat: "500,000",
    tongnhan: "39,500,000",
  },
  {
    id: 3,
    ten: "Phan Ken",
    ma: "NV003",
    chucvu: "Giám đốc Marketing",
    phongban: "Marketing",
    luongthang: "30,000,000",
    sogiolam: 150,
    dukien: "30,000,000",
    phat: "1,000,000",
    tongnhan: "29,000,000",
  },
  {
    id: 4,
    ten: "Lê Minh Hoàng",
    ma: "NV004",
    chucvu: "Nhân viên kế toán",
    phongban: "Kế toán",
    luongthang: "15,000,000",
    sogiolam: 140,
    dukien: "15,000,000",
    phat: "300,000",
    tongnhan: "14,700,000",
  },
];

const BangLuong = () => {
  const { id } = useParams();
  const employee = employees.find((emp) => emp.id === parseInt(id));

  if (!employee) {
    return (
      <h3 style={{ padding: "20px", color: "red" }}>
        Không tìm thấy thông tin lương
      </h3>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h3>Bảng Lương Nhân Sự - {employee.ten}</h3>
      <CTable striped hover responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Tên</CTableHeaderCell>
            <CTableHeaderCell>Mã</CTableHeaderCell>
            <CTableHeaderCell>Chức vụ</CTableHeaderCell>
            <CTableHeaderCell>Phòng Ban</CTableHeaderCell>
            <CTableHeaderCell>Lương tháng</CTableHeaderCell>
            <CTableHeaderCell>Số giờ làm</CTableHeaderCell>
            <CTableHeaderCell>Dự kiến</CTableHeaderCell>
            <CTableHeaderCell>Phạt</CTableHeaderCell>
            <CTableHeaderCell>Tổng nhận</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          <CTableRow>
            <CTableDataCell>1</CTableDataCell>
            <CTableDataCell>{employee.ten}</CTableDataCell>
            <CTableDataCell>{employee.ma}</CTableDataCell>
            <CTableDataCell>{employee.chucvu}</CTableDataCell>
            <CTableDataCell>{employee.phongban}</CTableDataCell>
            <CTableDataCell>{employee.luongthang}</CTableDataCell>
            <CTableDataCell>{employee.sogiolam}</CTableDataCell>
            <CTableDataCell>{employee.dukien}</CTableDataCell>
            <CTableDataCell>{employee.phat}</CTableDataCell>
            <CTableDataCell>{employee.tongnhan}</CTableDataCell>
          </CTableRow>
        </CTableBody>
      </CTable>
    </div>
  );
};

export default BangLuong;
